import type { ClikArtItem } from '@/api/types/clikart'
import { resolvePlacedClikArtId } from '@/lib/clikart/sync-clikart-placement-from-shapes'
import type { ShapeData } from '@/lib/shapes/types/shape-data'

/**
 * Whether a shape's ClikArt fill has an art id but nothing to draw. A ClikArt that arrives as an id
 * alone (a template's, or one authored in the legacy app: the NSD never stores a preview URL) draws
 * as an empty frame until its URL is looked up by `artId`.
 */
export function shapeNeedsClikArtPreview(shape: ShapeData): boolean {
  return resolvePlacedClikArtId(shape) != null && !shape.photoFill?.previewUrl
}

/**
 * The patch that gives a ClikArt fill its preview, from the looked-up art. Null when the shape
 * isn't a ClikArt fill or the art has no image URL. The same `scrUrl` the gallery places with.
 */
export function clikArtPreviewPatch(
  shape: ShapeData,
  item: ClikArtItem
): Partial<ShapeData> | null {
  if (!shape.photoFill || !item.scrUrl) return null

  return {
    photoFill: {
      ...shape.photoFill,
      previewUrl: item.scrUrl,
      displayName: shape.photoFill.displayName || item.displayName,
    },
  }
}
